var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs_wrap"},_vm._l((_vm.loginTypes),function(item,index){return _c('div',{key:index,staticClass:"item",class:_vm.value === item.value ? 'active' : '',on:{"click":function($event){return _vm.$emit('update',item.value)}}},[_vm._v(" "+_vm._s(_vm.$t('loginType.'+item.title))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }